{
	"title": "Opmerkingen",
	"statuses": {
		"inValidation": "In validatie",
		"rejected": "Afgewezen",
		"assured": "Bevestigd",
		"flagged": "Gemarkeerd",
		"resolved": "Opgelost"
	}
}
